import { IHeaderParams } from 'ag-grid-community';
import { FC } from 'react';

const RedditReportsHeader: FC<IHeaderParams> = (params) => (
	<div className="px-[8px] truncate">
		{params.displayName}
	</div>
);

export default RedditReportsHeader;
